import { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import { useAppInfo } from '../context/AppContext';
import './AuthPage.css';

function EyeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={20} height={20}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export default function SignupPage() {
  const { logoUrl } = useAppInfo();
  const [email, setEmail] = useState('');
  const [scanCode, setScanCode] = useState('');
  const [scanVisible, setScanVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiClient.post('/Authentication/PwaSignup', { email, scanCode });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="auth-page">
        {logoUrl && <img src={logoUrl} alt="Logo" className="auth-page-logo" />}
        <div className="auth-card">
          <h1 className="auth-title">Please Check Your Email</h1>
          <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
            If we found an account matching your email and scan code, we sent you a link to set your password.
            The link expires in 24 hours.
          </p>
          <p className="auth-footer">
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      {logoUrl && <img src={logoUrl} alt="Logo" className="auth-page-logo" />}
      <div className="auth-card">
        <h1 className="auth-title">Create Account</h1>
        <form onSubmit={handleSubmit} className="auth-form">
          <label className="auth-label">
            Email
            <input
              className="auth-input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="auth-label">
            Scan Code
            <div className="auth-input-wrap">
              <input
                className="auth-input"
                type={scanVisible ? 'text' : 'password'}
                autoComplete="off"
                placeholder="Your member scan code"
                value={scanCode}
                onChange={(e) => setScanCode(e.target.value)}
                required
              />
              <button
                type="button"
                className="auth-eye"
                onMouseDown={() => setScanVisible(true)}
                onMouseUp={() => setScanVisible(false)}
                onMouseLeave={() => setScanVisible(false)}
                onTouchStart={() => setScanVisible(true)}
                onTouchEnd={() => setScanVisible(false)}
                tabIndex={-1}
                aria-label="Hold to reveal scan code"
              >
                <EyeIcon />
              </button>
            </div>
          </label>
          {error && <p className="auth-error">{error}</p>}
          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send Access Link'}
          </button>
        </form>
        <p className="auth-footer">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
